// extracted by mini-css-extract-plugin
export default {"background":"HeroSection_background__1AZyO","imageWrapper":"HeroSection_imageWrapper__ilHz9","image":"HeroSection_image__ErKKW","loaded":"HeroSection_loaded__Onq-a"};